<style scoped lang="scss">
.property-modal {
    .uk-modal-dialog {
        width: 800px;
    }
}

    .company {
        padding: 20px;
        font-size: 1.2em;
    }
</style>

<template>
    <vk-modal class="property-modal uk-width-1-1" :show.sync="isOpen">
        <vk-modal-title>Connect Company</vk-modal-title>

        <div class="uk-grid">
            <div class="uk-width-1-1 uk-article-lead">
                <span>Select an Company</span>
            </div>

            <div v-for="org in organizations" class="uk-width-1-1 uk-width-medium-1-2" @click="selectOrganization(org)">
                <div class="company">
                    {{ org.organization_name }}
                </div>
            </div>
        </div>
    </vk-modal>
</template>

<script>
    import AddressForm from "./AddressForm";
    export default {
        name: "SelectOrganizationModal",

        data() {
            return {
                isOpen: false,
                organizations: [],
            }
        },
        methods: {
            open(organizations) {
                this.organizations = organizations;
                this.isOpen = true;
            },

            selectOrganization(organization) {
                this.$emit('select', organization);
                this.isOpen = false;
            }
        }
    }
</script>
